/* eslint-disable import/no-cycle */
import {
	set,
	setIsLoadingLoaded,
	clear,
	setSubItemsMap,
} from './actions';
import {
	fetchLinesAggs
} from '../../../../../scanline/redux/LinesProjectsReports/api/linesaggs';
import {
	selectIsLoaded,
	selectIsLoading
} from '../selectors';
import LINES_AGGS_UTILS from '../util';



const thunkSet = items => (dispatch) => {
	dispatch(set({ items }));
	dispatch(setSubItemsMap({ subItemsMap: LINES_AGGS_UTILS.createMap(items)}));
};

const thunkLoad = () => (dispatch) => {
	dispatch(clear());
	dispatch(
		setIsLoadingLoaded({
			isLoading: true,
			isLoaded: false
		})
	);
	fetchLinesAggs('Aegion').then(items => {
		dispatch(thunkSet(items));
		dispatch(
			setIsLoadingLoaded({
				isLoading: false,
				isLoaded: true
			})
		);
	});
};

const thunkLoadIfNotLoaded = () => (dispatch, getState) => {
	const isLoaded = selectIsLoaded(getState());
	const isLoading = selectIsLoading(getState());

	if (!isLoaded && !isLoading) {
		dispatch(thunkLoad());
	}
};

export {
	thunkSet,
	thunkLoad,
	thunkLoadIfNotLoaded,
};
